export { default as getPhoneSimpleDialogLocaleEs } from './localeEs';
export { default as getPhoneSimpleDialogLocalePt } from './localePt';
export { default as getPhoneSimpleDialogLocaleEn } from './localeEn';
